import {
  publicHttpClient,
  type AxiosRequestConfig,
} from '@ahm/api-wrappers-core';
import { apiRoutes } from './api-routes';

export interface GetSearchAutocompleteResponse {
  suggestions: string[];
}
export interface GetSearchAutocompleteParams {
  text: string;
}

export const getSearchAutocompleteFn = async (
  params?: GetSearchAutocompleteParams,
  config: AxiosRequestConfig = {}
) => {
  const response = await publicHttpClient.get<GetSearchAutocompleteResponse>(
    apiRoutes.ahafood.store.get_search_autocomplete,
    {
      params,
      ...config,
    }
  );

  return response?.data;
};
